import axios from '@/core/axios';

import { CustomerDocument, CustomerDocumentTypeOption, CustomerDocumentUpload } from './customer-documents.types';

export class CustomerDocumentsService {
  listTypes(): Promise<CustomerDocumentTypeOption[]> {
    return axios.get<CustomerDocumentTypeOption[]>('/customer-documents/types').then(resp => resp?.data || []);
  }

  listForCustomer(customerId: number | string): Promise<CustomerDocument[]> {
    return axios.get<CustomerDocument[]>(`/customers/${customerId}/documents`).then(resp => resp?.data || []);
  }

  create(customerId: number | string, upload: CustomerDocumentUpload): Promise<CustomerDocument> {
    if (!customerId) throw new Error('Missing customer id in create document');
    const formData = new FormData();
    formData.append('file', upload.file);
    formData.append('document_type', upload.document_type);
    if (upload.name) formData.append('name', upload.name);
    return axios
      .post<CustomerDocument>(`/customers/${customerId}/documents`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then(resp => resp?.data);
  }

  get(documentId: number | string): Promise<CustomerDocument> {
    return axios.get<CustomerDocument>(`/customer-documents/${documentId}`).then(resp => resp?.data);
  }

  download(documentId: number | string): Promise<string> {
    return axios.get<string>(`/customer-documents/${documentId}/download`).then(resp => resp?.data);
  }

  delete(documentId: number | string): Promise<void> {
    return axios.delete<void>(`/customer-documents/${documentId}`).then(resp => resp?.data);
  }
}

export const customerDocumentsService = new CustomerDocumentsService();
